<template>
  <div class="pastMenu" ref="box">
    <div
      style="font-size: 18px;font-weight: 500;text-align: center;padding-top: 5px;"
    >
      {{ canteenName }} - 往期菜单
    </div>

    <div v-if="loading" style="text-align: center;margin-top: 30px;">
      <van-loading type="spinner" />
    </div>
    <div v-else class="main-content">
      <div class="introduce">
        <van-tabs @click="changeMeun" v-model="topActive" type="line">
          <van-tab
            v-for="(item, index) in menu"
            :key="index"
            :title="item.menuName"
            title-active-color="red"
            title-inactive-color="white"
            background="#ffd63c"
          ></van-tab>
        </van-tabs>
      </div>
      <div class="tabs" ref="tabsRef">
        <div
          v-for="(item, index) in menu[topActive]
            ? menu[topActive].menu.weeks
            : []"
          :key="index"
          class="tabItem"
          :id="'b' + index"
          :class="active == index ? 'active' : ''"
          style="margin-left:10px"
          @click="goAnchor('a' + index, index)"
        >
          {{ item.week }}
        </div>
      </div>
      <div class="foodList" ref="foodList">
        <div class="foodList-bg" ref="foodListBg">
          <div
            v-for="(item, index) in menu[topActive]
              ? menu[topActive].menu.weeks
              : []"
            :key="index"
            style="padding:0 12px;box-sizing: border-box;"
            :id="'a' + index"
          >
            <div
              style="color: #333;font-size: 18px;font-weight: 500;height:42px;line-height:42px;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;;"
            >
              {{ item.time }}
            </div>
            <div
              v-if="item.big.length"
              style="height: 172px;padding:0 10px;box-sizing: border-box;"
              class="menubg"
            >
              <div
                style="color: #BC4B00;;font-size: 16px;font-weight: 500;height:42px;line-height:42px;"
              >
                大荤
              </div>

              <div class="scroll">
                <div
                  class="scrollItemBox"
                  v-for="(item, index) in item.big"
                  :key="index"
                >
                  <div class="scrollItem">
                    <img
                      v-if="item.foodImgPaths && item.foodImgPaths[0]"
                      style="width:100%;height:100%;"
                      :src="imgUrl(item.foodImgPaths[0].imgUrl)"
                    />
                    <img
                      v-else
                      style="width:100%;height:100%;"
                      src="../../assets/images/caipin_empty.png"
                    />
                  </div>
                  <div
                    style="margin:6px 0 4px;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                    class="ellipsis"
                  >
                    {{ item.dishName }}
                  </div>
                  <div
                    style="color:#F04242;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                  >
                    {{ item.dishPrice }}元
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="item.small.length"
              style="height: 172px;padding:0 10px;box-sizing: border-box;"
              class="menubg1"
            >
              <div
                style="color: #BC4B00;;font-size: 16px;font-weight: 500;height:42px;line-height:42px;"
              >
                小荤
              </div>

              <div class="scroll">
                <div
                  class="scrollItemBox"
                  v-for="(item, index) in item.small"
                  :key="index"
                >
                  <div class="scrollItem">
                    <img
                      v-if="item.foodImgPaths && item.foodImgPaths[0]"
                      style="width:100%;height:100%;"
                      :src="imgUrl(item.foodImgPaths[0].imgUrl)"
                    />
                    <img
                      v-else
                      style="width:100%;height:100%;"
                      src="../../assets/images/caipin_empty.png"
                    />
                  </div>
                  <div
                    style="margin:6px 0 4px;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                    class="ellipsis"
                  >
                    {{ item.dishName }}
                  </div>
                  <div
                    style="color:#F04242;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                  >
                    {{ item.dishPrice }}元
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="item.veg.length"
              style="height: 172px;padding:0 10px;box-sizing: border-box;"
              class="menubg2"
            >
              <div
                style="color: #BC4B00;;font-size: 16px;font-weight: 500;height:42px;line-height:42px;"
              >
                素菜
              </div>

              <div class="scroll">
                <div
                  class="scrollItemBox"
                  v-for="(item, index) in item.veg"
                  :key="index"
                >
                  <div class="scrollItem">
                    <img
                      v-if="item.foodImgPaths && item.foodImgPaths[0]"
                      style="width:100%;height:100%;"
                      :src="imgUrl(item.foodImgPaths[0].imgUrl)"
                    />
                    <img
                      v-else
                      style="width:100%;height:100%;"
                      src="../../assets/images/caipin_empty.png"
                    />
                  </div>
                  <div
                    style="margin:6px 0 4px;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                    class="ellipsis"
                  >
                    {{ item.dishName }}
                  </div>
                  <div
                    style="color:#F04242;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                  >
                    {{ item.dishPrice }}元
                  </div>
                </div>
              </div>
            </div>

            <div
              style="height:42px;line-height:42px;display:flex;justify-content: space-between;padding:0 13px;box-sizing:border-box"
            >
              <div style="font-size: 16px;font-weight: 500;">长者套餐</div>
              <div style="color: #8F8F8F;font-size: 12px;">
                社区65岁及以上人群专享
              </div>
            </div>
            <!-- 套餐 -->
            <template v-for="(item, index) in menu[topActive].menu.grops">
              <div
                :key="index"
                v-if="
                  item.value === 'twoMeatTwoVegetables' &&
                    menu[topActive].menu.twoMeatTwoVegetables
                "
                style="height:34px;line-height:42px;display:flex;align-items: center;justify-content: space-between;padding:0 13px;box-sizing:border-box"
              >
                <div
                  style="font-size: 16px;font-weight: 500;display:flex;align-items: center;"
                >
                  <div class="tag">套餐{{ index + 1 }}</div>
                  <span style="font-size: 14px;margin-left:10px"
                    >两大荤两素</span
                  >
                </div>
                <div
                  style="color: #FF563C;font-size: 14px;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                >
                  {{ menu[topActive].menu.twoMeatTwoVegetables }}元
                </div>
              </div>
              <div
                :key="index"
                v-if="
                  item.value === 'oneMeatTwoMeatVegetable' &&
                    menu[topActive].menu.oneMeatTwoMeatVegetable
                "
                style="height:34px;line-height:42px;display:flex;align-items: center;justify-content: space-between;padding:0 13px;box-sizing:border-box"
              >
                <div
                  style="font-size: 16px;font-weight: 500;display:flex;align-items: center;"
                >
                  <div class="tag">套餐{{ index + 1 }}</div>
                  <span style="font-size: 14px;margin-left:10px"
                    >一大荤两小荤一素</span
                  >
                </div>
                <div
                  style="color: #FF563C;font-size: 14px;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                >
                  {{ menu[topActive].menu.oneMeatTwoMeatVegetable }}元
                </div>
              </div>
              <div
                :key="index"
                v-if="
                  item.value === 'fewMeatVegetables' &&
                    menu[topActive].menu.fewMeatVegetables
                "
                style="height:34px;line-height:42px;display:flex;align-items: center;justify-content: space-between;padding:0 13px;box-sizing:border-box"
              >
                <div
                  style="font-size: 16px;font-weight: 500;display:flex;align-items: center;"
                >
                  <div class="tag">套餐{{ index + 1 }}</div>
                  <span style="font-size: 14px;margin-left:10px"
                    >一大荤一小荤两素</span
                  >
                </div>
                <div
                  style="color: #FF563C;font-size: 14px;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                >
                  {{ menu[topActive].menu.fewMeatVegetables }}元
                </div>
              </div>
              <div
                :key="index"
                v-if="
                  item.value === 'littleMeatVegetable' &&
                    menu[topActive].menu.littleMeatVegetable
                "
                style="height:34px;line-height:42px;display:flex;align-items: center;justify-content: space-between;padding:0 13px;box-sizing:border-box"
              >
                <div
                  style="font-size: 16px;font-weight: 500;display:flex;align-items: center;"
                >
                  <div class="tag">套餐{{ index + 1 }}</div>
                  <span style="font-size: 14px;margin-left:10px"
                    >一大荤一小荤一素</span
                  >
                </div>
                <div
                  style="color: #FF563C;font-size: 14px;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                >
                  {{ menu[topActive].menu.littleMeatVegetable }}元
                </div>
              </div>
              <div
                :key="index"
                v-if="
                  item.value === 'vegetable' && menu[topActive].menu.vegetable
                "
                style="height:34px;line-height:42px;display:flex;align-items: center;justify-content: space-between;padding:0 13px;box-sizing:border-box"
              >
                <div
                  style="font-size: 16px;font-weight: 500;display:flex;align-items: center;"
                >
                  <div class="tag">套餐{{ index + 1 }}</div>
                  <span style="font-size: 14px;margin-left:10px"
                    >一小荤一素</span
                  >
                </div>
                <div
                  style="color: #FF563C;font-size: 14px;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                >
                  {{ menu[topActive].menu.vegetable }}元
                </div>
              </div>
            </template>

            <!-- 爱以德 -->
            <template v-if="false && canteenId === '310101002002'">
              <div
                style="height:34px;line-height:42px;display:flex;align-items: center;justify-content: space-between;padding:0 13px;box-sizing:border-box"
              >
                <div
                  style="font-size: 16px;font-weight: 500;display:flex;align-items: center;"
                >
                  <div class="tag">套餐1</div>
                  <span style="font-size: 14px;margin-left:10px"
                    >一大荤两小荤一素</span
                  >
                </div>
                <div
                  style="color: #FF563C;font-size: 14px;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                >
                  20元
                </div>
              </div>
              <div
                style="height:34px;line-height:42px;display:flex;align-items: center;justify-content: space-between;padding:0 13px;box-sizing:border-box"
              >
                <div
                  style="font-size: 16px;font-weight: 500;display:flex;align-items: center;"
                >
                  <div class="tag">套餐2</div>
                  <span style="font-size: 14px;margin-left:10px"
                    >一大荤一小荤一素</span
                  >
                </div>
                <div
                  style="color: #FF563C;font-size: 14px;font-family:Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,HeitiSC,WenQuanYi Micro Hei,sans-serif;"
                >
                  16元
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- 固定定位--背景图等 -->
    <div class="flex flexBg1">
      <img src="@/assets/images/food5.png" alt />
    </div>
    <div class="flex flexBg2">
      <img src="@/assets/images/food2.png" alt />
    </div>
    <div class="flex flexBg3">
      <img src="@/assets/images/food3.png" alt />
    </div>
    <div class="flex flexBg4">
      <img src="@/assets/images/food4.png" alt />
    </div>
    <div class="flex flexBg5">
      <img src="@/assets/images/food5.png" alt />
    </div>
    <div class="flex flexBg6">
      <img src="@/assets/images/food6.png" alt />
    </div>
  </div>
</template>

<script>
import { selectMenuList, foodMenuManage } from '@/api/weeklyMenu';
import { areaCode } from '@/common/constants.js';
// import { Tab, Tabs } from 'vant';
// import Vue from 'vue/types/umd';
export default {
  name: 'User',
  data() {
    return {
      topActive: 0,

      isClick: false,
      active: 0,
      menu: [],
      menuList: [
        {
          id: 1,
          label: '两大荤两素',
          value: 'twoMeatTwoVegetables',
        },
        {
          id: 2,
          label: '一大荤两小荤一素',
          value: 'oneMeatTwoMeatVegetable',
        },
        {
          id: 3,
          label: '一大荤一小荤两素',
          value: 'fewMeatVegetables',
        },
        {
          id: 4,
          label: '一大荤一小荤一素',
          value: 'littleMeatVegetable',
        },
        {
          id: 5,
          label: '一小荤一素',
          value: 'vegetable',
        },
      ],
      weeklyMenuImg: [],
      canteenId: '',
      canteenName: '',
      loading: false,
    };
  },
  watch: {
    active(newVal) {
      this.$nextTick(() => {
        this.setCentert();
      });
    },
  },
  computed: {
    imgUrl() {
      return function(url) {
        if (!url) return '';
        return `${process.env.VUE_APP_API_IMGURL}` + url;
      };
    },
  },
  methods: {
    setCentert() {
      // 外层整个tab
      let tabsRef = this.$refs.tabsRef;
      // 单个tab
      let activeNode = document.querySelector('.tabItem.active');
      // 元素距离滑块左边距离  -  居中时元素到窗口左边距离  =  滚动条滑动的距离
      let scrollWidth =
        activeNode.offsetLeft -
        (tabsRef.clientWidth - activeNode.clientWidth) / 2;
      tabsRef.scrollLeft = scrollWidth;
    },
    goAnchor(selector, index) {
      this.active = index;
      this.isClick = true;
      setTimeout(() => {
        var el = document.getElementById(selector);
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    },
    handleScroll(e) {
      console.log(this.isClick);
      if (this.isClick) return;
      //获取dom滚动距离
      const scrollTop = this.$refs.foodListBg.scrollTop;
      //获取可视区高度
      const offsetHeight = this.$refs.foodListBg.offsetHeight;
      //获取滚动条总高度
      const scrollHeight = this.$refs.foodListBg.scrollHeight;

      //xqConList 为目录内容列表
      for (let i = 0; i < 10; i++) {
        //offsetTop: 获取当前元素到其定位父级（offsetParent）的顶部距离
        let offset_before = this.$el.querySelector('#a' + i).offsetTop;
        let offset_after =
          this.$el.querySelector('#a' + i).offsetHeight + offset_before;
        //根据xqItem离顶部距离判断滚动距离落在哪两个item之间
        if (scrollTop >= offset_before && scrollTop < offset_after) {
          if (scrollTop + offsetHeight >= scrollHeight) {
            // 把距离顶部的距离加上可视区域的高度 等于或者大于滚动条的总高度就是到达底部
            // console.log("已滚动到底部");
            if (this.active < i) {
              this.active = i;
            }
          } else {
            this.active = i;
          }
          break;
        }
      }
    },
    getData() {
      this.loading = true;
      foodMenuManage({ area: this.canteenId, pageNum: 1, pageSize: 9999 }).then(
        (res) => {
          if (res.code === 0) {
            const weekDays = [
              '周日',
              '周一',
              '周二',
              '周三',
              '周四',
              '周五',
              '周六',
            ];
            let menu = res.data.list.map((item) => {
              let menu = item;
              let weeks = Object.keys(item.dishesByDate)
                .sort(function(a, b) {
                  return (
                    new Date(a.replace(/-/g, '/')).getTime() -
                    new Date(b.replace(/-/g, '/')).getTime()
                  ); //升序排序
                })
                .map((i) => {
                  return {
                    time: i,
                    week: weekDays[new Date(i.replace(/-/g, '/')).getDay()],
                    big: item.dishesByDate[i].filter(
                      (item) => item.dishTypeName == '大荤',
                    ),
                    small: item.dishesByDate[i].filter(
                      (item) => item.dishTypeName == '小荤',
                    ),
                    veg: item.dishesByDate[i].filter(
                      (item) => item.dishTypeName == '素菜',
                    ),
                  };
                });
              menu.weeks = weeks;
              const arr = [];
              //套餐grops start
              console.log('menu', menu);
              // twoMeatTwoVegetables、oneMeatTwoMeatVegetable、fewMeatVegetables、littleMeatVegetable、vegetable
              this.menuList.forEach((item) => {
                if (menu[item.value]) {
                  arr.push({
                    label: item.label,
                    value: item.value,
                    price: menu[item.value],
                  });
                }
              });
              menu.grops = arr;
              return {
                menuName: item.menuName,
                menu: menu,
              };
            });
            this.menu = menu;
            this.loading = false;
            console.log(menu);
          }
        },
      );
      return;
      selectMenuList({
        startPagination: 'N',
        areaCode: '310101002000',
        accountDataType: 'prod',
      }).then((res) => {
        if (res.code == 0 && res.data) {
          this.menuNameList = res.data;
          res.data[0].filesInfoVo.forEach((item) => {
            let imgUrl = `${process.env.VUE_APP_API_IMGURL}${item.imgUrl}`;
            this.weeklyMenuImg.push(imgUrl);
          });
          // console.log(this.menuNameList);
          this.$nextTick(() => {
            this.countHeight();
          });
        }
      });
    },
    // 计算高度
    countHeight() {
      setTimeout(() => {
        let height = this.$refs.foodListBg.offsetHeight;
        console.log(height);
        // 给最外层盒子加高度
        this.$refs.foodList.style.height = `${height}px`;
        this.$refs.box.style.height = `${160 + height}px`;
      }, 30);
    },
    // 菜单切换
    changeMeun(name, title) {
      this.$refs.foodListBg.scrollTop = 0;
      this.isClick = false;
      // this.weeklyMenuImg = [];
      // this.menuNameList.forEach((item) => {
      //   if (item.menuName == title) {
      //     if (item.filesInfoVo) {
      //       item.filesInfoVo.forEach((ite) => {
      //         let imgUrl = `${process.env.VUE_APP_API_IMGURL}${ite.imgUrl}`;
      //         this.weeklyMenuImg.push(imgUrl);
      //       });
      //     }
      //   }
      // });
      // this.$nextTick(() => {
      //   this.countHeight();
      // });
    },
  },
  async mounted() {
    const that = this;
    this.canteenId = this.$route.query.canteenId;
    this.canteenName = this.$route.query.canteenName;
    window.document.title = `${this.canteenName}往期菜单`;
    await this.getData();
    this.$nextTick(() => {
      this.$refs.foodListBg.addEventListener('scroll', this.handleScroll);
      this.$refs.foodListBg.addEventListener('touchstart', function() {
        that.isClick = false;
      });
    });
  },
};
</script>
<style>
.pastMenu {
  .van-tabs,
  .van-tab,
  .van-tabs__nav {
    background: #ffd63c;
  }
  .van-tab {
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-style: normal;
    padding: 0 8px;
    margin: 0 5px;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    border-radius: 4px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    /* text-emphasis:; */
  }
  .van-tab .van-tab__text {
    display: inline-block;
    width: 100%;
    height: 40px;
    line-height: 40px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .van-tab--active {
    width: 120px;
    height: 40px;
    line-height: 40px;
    background: #fff;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .van-tabs__line {
    display: none;
  }
}
</style>
<style lang="scss" scoped>
.pastMenu {
  position: relative;
  width: 100vw;
  overflow: hidden;
  min-height: 100vh;
  // height: 100vh;
  // padding: 20px;
  background: #ffd63c;

  .main-content {
    position: relative;
    top: 5px;

    .introduce {
      width: 100%;
      position: absolute;
      z-index: 999;
      top: 5px;
      left: 0;
      // height: 40px;
      // overflow: hidden;
      background: #ffd63c;
    }
    .tabs {
      margin: 0 auto;
      position: absolute;
      z-index: 5;
      width: 338px;
      height: 50px;
      left: 23px;
      top: 45px;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #333;
      overflow-x: scroll;
      // overflow: hidden;
      .tabItem {
        flex-shrink: 0;
        width: 44px;
        height: 28px;
        border-radius: 4px;
        background: transparent;
        text-align: center;
        line-height: 28px;
      }
      .active {
        background: #fff;
      }
    }
    .foodList {
      margin: 0 auto;
      position: absolute;
      z-index: 5;
      width: 338px;
      left: 50%;
      transform: translateX(-50%);
      top: 90px;
      // background: #fff5d2;
      border-radius: 8px;
      .img1,
      .img2 {
        position: absolute;
        z-index: 10;
      }
      .img1 {
        top: -12px;
        left: 60px;
      }
      .img2 {
        top: -12px;
        right: 60px;
      }
      .foodList-bg {
        width: 100%;
        height: calc(100vh - 130px);
        overflow: hidden;
        overflow-y: scroll;
        position: absolute;
        z-index: 2;
        background: #ffffff;
        border: 3px solid #ffe582;
        border-radius: 8px;

        top: 7px;

        > div {
          width: 100%;
          overflow: hidden;
          img {
            width: 100%;
            height: auto;
            margin-bottom: 15px;
          }
        }
      }
    }
    .scroll {
      display: flex;
      overflow-x: scroll;
      overflow-y: hidden;
      scrollbar-width: none;
      -ms-overflow-style: none;

      .scrollItemBox {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 5px;
        font-size: 14px;
      }
      .scrollItem {
        width: 80px;
        height: 70px;
        border-radius: 8px;
        overflow: hidden;

        flex-shrink: 0;
      }
    }
    .scroll::-webkit-scrollbar {
      display: none;
    }
    .ellipsis {
      text-align: center;
      width: 85px;
      max-width: 85px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .tag {
      width: 38px;
      height: 16px;
      border-radius: 2px;
      background: #f58506;
      color: #fff;
      font-size: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .menubg {
      background-image: url('../../assets/images/大荤.png');
      background-size: 100% 100%;
    }
    .menubg1 {
      background-image: url('../../assets/images/小荤.png');
      background-size: 100% 100%;
    }
    .menubg2 {
      background-image: url('../../assets/images/素菜.png');
      background-size: 100% 100%;
    }
  }

  .flex {
    position: fixed;
    z-index: 1;
  }
  .flexBg1 {
    top: 65px;
    right: 0;
  }
  .flexBg2 {
    top: 145px;
    left: 0;
  }
  .flexBg3 {
    top: 234px;
    right: 0;
  }
  .flexBg4 {
    top: 320px;
    left: 0;
  }
  .flexBg5 {
    top: 460px;
    right: 0;
  }
  .flexBg6 {
    top: 600px;
    left: 0;
  }
  ::v-deep .van-hairline--top-bottom::after,
  .van-hairline-unset--top-bottom::after {
    border-width: 0;
  }
}
</style>
